<template>
    <div :style="{'background-image': 'url(' + require('../assets/newforest.jpg') + ')'}" id="app">

    <vue-particles
      color="#dedede"
      :particleOpacity="0.2"
      :particlesNumber="30"
      shapeType="circle"
      :particleSize="12"
      linesColor="#dedede"
      :linesWidth="0"
      :lineLinked="false"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="1"
      :hoverEffect="true"
      hoverMode="push"
      :clickEffect="false"
      clickMode="push"
    >
    </vue-particles>
    <v-layout
      column
      wrap
      align-center
    >
      <v-flex xs12>
        <v-container grid-list-xl>
          <v-layout row wrap align-center>

            <v-flex xs12 md4> <!-- column 1 -->
              <v-container fluid grid-list-lg>
                <v-layout row wrap>

                  <v-flex xs12>
                    <v-card color="green darken-3" class="white--text">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/spotify.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Spotify</div>
                              <div>Witch of the Vale on Spotify</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn flat dark v-on:click="goUrl('https://open.spotify.com/artist/7axp614rqaTEKnaeQJ8F3V')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-card color="white darken-2" class="black--text lighten-2">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/Itunes-logo-button.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">iTunes</div>
                              <div>Witch of the Vale on iTunes</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="black--text" flat dark v-on:click="goUrl('https://itunes.apple.com/gb/artist/witch-of-the-vale/1439507789')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-card color="orange darken-3" class="white--text lighten-2">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/soundcloud.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Soundcloud</div>
                              <div>Witch of the Vale on Soundcloud</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="white--text" flat dark v-on:click="goUrl('https://soundcloud.com/witch-of-the-vale')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-flex> <!-- end of column 1 -->

            <v-flex xs12 md4>  <!-- column 2 -->
              <v-container fluid grid-list-lg>
                <v-layout row wrap>

                  <v-flex xs12>
                    <v-card color="blue-grey darken-2" class="white--text lighten-2">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                          :src="require('../assets/bandcamp-logo.png')"
                          height="125px"
                          contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Bandcamp</div>
                              <div>Witch of the Vale on Bandcamp</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="white--text" flat dark v-on:click="goUrl('https://witchofthevale.bandcamp.com/')">Buy now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-card color="red lighten-1" class="white--text lighten-2">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/Youtube_music_icon.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Youtube</div>
                              <div>Witch of the Vale on Youtube Music</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="white--text" flat dark v-on:click="goUrl('https://music.youtube.com/channel/UC3JGmOtTsWmy93stgKM4iUQ')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-card color="white" class="black--text">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/prime-music.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Amazon</div>
                              <div>Witch of the Vale on Amazon</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="black--text lighten-2" flat dark v-on:click="goUrl('https://www.amazon.co.uk/Commemorate-Explicit-Witch-Vale/dp/B08MYJVXQT')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-container>
            </v-flex>

            <v-flex xs12 md4>  <!-- column 2 -->
              <v-container fluid grid-list-lg>
                <v-layout row wrap>

                  <v-flex xs12>
                    <v-card color="white" class="black--text">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/apple-music.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Apple Music</div>
                              <div>Witch of the Vale on Apple Music</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider dark></v-divider>
                      <v-card-actions>
                        <v-btn class="black--text" flat dark v-on:click="goUrl('https://tidal.com/browse/artist/10489923')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>     
                  
                  <v-flex xs12>
                    <v-card color="black" class="white--text">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/tidal.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Tidal</div>
                              <div>Witch of the Vale on Tiday</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider dark></v-divider>
                      <v-card-actions>
                        <v-btn class="white--text" flat dark v-on:click="goUrl('https://tidal.com/browse/artist/10489923')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex> 

                  <!-- <v-flex xs12>
                    <v-card color="black" class="grey--text lighten-2">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                          :src="require('../assets/avatar.jpg')"
                          height="125px"
                          contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Downloads</div>
                              <div>Witch of the Vale Downloads</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-card-text>
                        <br/>
                        <p>
                          People who purchased the Trust the Pain EP have highlighted they are unable to get an high quality download of Gods & Monsters.
                          <br/>
                          We attach a download link for a 24 bit, 48khz wav version of the song here
                        </p>
                          <br/>
                          <br/>
                      </v-card-text>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="white--text" target="_blank" :href=godsAndMonsters flat dark>Download - Gods & Monsters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex> -->

                  <v-flex xs12>
                    <v-card color="yellow lighten-2" class="black--text">
                      <v-layout>
                        <v-flex xs5>
                          <v-img
                            :src="require('../assets/deezer.png')"
                            height="125px"
                            contain
                          ></v-img>
                        </v-flex>
                        <v-flex xs7>
                          <v-card-title primary-title>
                            <div>
                              <div class="headline">Deezer</div>
                              <div>Witch of the Vale on Deezer</div>
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions>
                        <v-btn class="black--text" flat dark v-on:click="goUrl('https://www.deezer.com/en/artist/52872882')">Listen now</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-container>
            </v-flex>

          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    </div>
</template>

<style scoped>
  .v-card {
    overflow: hidden;
  }
  #particles-js { position: fixed; top: 44px; left: 0; width: 100%; height: 80%; } 
</style>

<script>
  export default {
    methods: {
      goUrl: function (link) {
        if (link){
          const win = window.open(link, '_blank', "modal=no");
          win.focus();
        }
      }
    },
        data () {
      return {
        godsAndMonsters: require('@/assets/Gods&Monsters.wav'),
      }
    }
  }
</script>
